var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#5754FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1530_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9419 13.3553C26.6303 12.7138 25.2427 12.2581 23.8158 12C23.638 12.3359 23.4304 12.7876 23.2872 13.147C21.7487 12.9052 20.2244 12.9052 18.7143 13.147C18.5712 12.7877 18.3588 12.3359 18.1794 12C16.7512 12.2582 15.3624 12.7151 14.0502 13.3586C11.4389 17.4831 10.731 21.505 11.0849 25.47C12.8169 26.8219 14.4953 27.6431 16.1455 28.1805C16.5556 27.591 16.9181 26.9669 17.2293 26.3147C16.6368 26.0789 16.0656 25.7884 15.5226 25.4465C15.6655 25.3358 15.805 25.2204 15.941 25.1005C19.2318 26.7094 22.8074 26.7094 26.059 25.1005C26.1955 25.2196 26.335 25.335 26.4773 25.4465C25.9334 25.7893 25.3612 26.0804 24.7675 26.3164C25.0805 26.9713 25.4423 27.596 25.8513 28.1821C27.503 27.6448 29.183 26.8236 30.915 25.47C31.3303 20.8736 30.2056 16.8886 27.9419 13.3552V13.3553ZM17.6777 23.0316C16.6898 23.0316 15.8796 22.0677 15.8796 20.8938C15.8796 19.72 16.6725 18.7544 17.6777 18.7544C18.6829 18.7544 19.493 19.7183 19.4757 20.8938C19.4773 22.0677 18.6829 23.0316 17.6777 23.0316ZM24.3223 23.0316C23.3344 23.0316 22.5243 22.0677 22.5243 20.8938C22.5243 19.72 23.3171 18.7544 24.3223 18.7544C25.3275 18.7544 26.1376 19.7183 26.1203 20.8938C26.1203 22.0677 25.3275 23.0316 24.3223 23.0316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1530_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.25,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDis);
export default __webpack_public_path__ + "static/media/dis.66d084717acdfa367fc599765db4bdb6.svg";
export { ForwardRef as ReactComponent };